/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
export * from './create-component.js';
//# sourceMappingURL=index.js.map